"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldCenterPropertyForm = exports.shouldShowEmailForm = exports.getShouldAutoSubmit = exports.getAvailableStartTimesForSelectedDate = exports.isSelectedDateAvailable = exports.getAvailableDates = exports.getGroupedAvailableTimes = exports.getAvailableStartTimes = exports.getOffline = exports.getAvailableTimePeriods = exports.getStartTimeIntervalMilliseconds = exports.getStartTimeIncrementMinutes = exports.getIsLegitimateInterest = exports.getLegalConsentOptions = exports.getLegalConsentEnabled = exports.getDurations = exports.getCustomParams = exports.getEditLinkURL = exports.getBookInfo = exports.getMeetingLength = exports.getEvent = exports.getUserTimezone = exports.getLanguageFromSettings = exports.getLocaleFromSettings = exports.getDisplayInfo = exports.shouldFetchAvailability = exports.getUserProfile = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _reselect = require("reselect");

var _FormFieldValidationSelector = require("MeetingsLib/selectors/FormFieldValidationSelector");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _RESTParamSelectors = require("MeetingsLib/selectors/RESTParamSelectors");

var _RequestStatusTypes = require("MeetingsBase/constants/RequestStatusTypes");

var _TimeRangeListUtils = require("MeetingsBase/utils/TimeRangeListUtils");

var _utils = require("MeetingsBase/utils/utils");

var _AvailabilityMilliseconds = _interopRequireDefault(require("MeetingsBase/models/AvailabilityMilliseconds"));

var _utils2 = require("MeetingsLib/utils/utils");

var _enums = require("MeetingsBase/constants/enums");

var _dates = require("MeetingsBase/constants/dates");

var getProfileFromProps = function getProfileFromProps(state, props) {
  return (0, _get.default)('profile', props);
};

var getProfileFromState = (0, _get.default)('profile');
var getRoundRobinProfile = (0, _getIn.default)(['bookingLifecycle', 'postResponse', 'organizer']);
var getForceOffline = (0, _get.default)('forceOffline');
var getPortalId = (0, _get.default)('portalId');
var getUserProfile = (0, _reselect.createSelector)([getProfileFromProps, getProfileFromState, getRoundRobinProfile], function (propsProfile, stateProfile, roundRobinProfile) {
  return propsProfile || roundRobinProfile || stateProfile;
});
exports.getUserProfile = getUserProfile;
var shouldFetchAvailability = (0, _reselect.createSelector)([_RequestStatusSelectors.getPublicAvailabilityInfoFetchStatus], function (availabilityInfoFetchStatus) {
  return availabilityInfoFetchStatus !== _RequestStatusTypes.STARTED && availabilityInfoFetchStatus !== _RequestStatusTypes.SUCCEEDED;
});
exports.shouldFetchAvailability = shouldFetchAvailability;

var getDisplayInfoProp = function getDisplayInfoProp(props) {
  return (0, _get.default)('displayInfo', props);
};

var getDisplayInfoState = (0, _getIn.default)(['bookInfo', 'customParams', 'displayInfo']);

var getDisplayInfo = function getDisplayInfo(state, props) {
  var propDisplayInfo = getDisplayInfoProp(props);
  var stateDisplayInfo = getDisplayInfoState(state);
  return propDisplayInfo || stateDisplayInfo;
};

exports.getDisplayInfo = getDisplayInfo;
var getLocaleFromSettings = (0, _getIn.default)(['bookInfo', 'customParams', 'locale']);
exports.getLocaleFromSettings = getLocaleFromSettings;
var getLanguageFromSettings = (0, _getIn.default)(['bookInfo', 'customParams', 'language']);
exports.getLanguageFromSettings = getLanguageFromSettings;
var getBookingLifecycle = (0, _get.default)('bookingLifecycle');
var getBookInfoState = (0, _get.default)('bookInfo');
var getUserTimezone = (0, _get.default)('userTimezone');
exports.getUserTimezone = getUserTimezone;
var getEvent = (0, _reselect.createSelector)([getBookingLifecycle], function (bookingLifecycle) {
  return bookingLifecycle.event;
});
exports.getEvent = getEvent;
var getMeetingLength = (0, _reselect.createSelector)([getEvent], function (event) {
  return event.duration;
});
exports.getMeetingLength = getMeetingLength;
var getBookInfo = (0, _reselect.createSelector)([getBookInfoState, getDisplayInfo], function (stateBookInfo, displayInfo) {
  if (stateBookInfo) {
    return stateBookInfo.setIn(['customParams', 'displayInfo'], displayInfo);
  }

  return stateBookInfo;
});
exports.getBookInfo = getBookInfo;
var getEditLinkURL = (0, _reselect.createSelector)([getBookInfo, getPortalId], function (bookInfo, portalId) {
  var linkId = bookInfo.linkId,
      linkType = bookInfo.linkType;
  var linkEditParam = (0, _utils2.getLinkEditParam)(linkType);
  var baseURL = (0, _utils2.getAdminDomain)();
  return "https://" + baseURL + "/meetings/" + portalId + "/" + linkEditParam + "/" + linkId;
});
exports.getEditLinkURL = getEditLinkURL;
var getCustomParams = (0, _reselect.createSelector)([getBookInfo], function (bookInfo) {
  return (0, _get.default)('customParams', bookInfo);
});
exports.getCustomParams = getCustomParams;
var getDurations = (0, _reselect.createSelector)([getCustomParams], function (customParams) {
  return (0, _get.default)('durations', customParams);
});
exports.getDurations = getDurations;
var getLegalConsentEnabled = (0, _reselect.createSelector)([getCustomParams], function (customParams) {
  return (0, _get.default)('legalConsentEnabled', customParams);
});
exports.getLegalConsentEnabled = getLegalConsentEnabled;
var getLegalConsentOptions = (0, _reselect.createSelector)([getCustomParams], function (customParams) {
  return (0, _get.default)('legalConsentOptions', customParams);
});
exports.getLegalConsentOptions = getLegalConsentOptions;
var getIsLegitimateInterest = (0, _reselect.createSelector)([getLegalConsentOptions], function (legalConsentOptions) {
  return (0, _get.default)('isLegitimateInterest', legalConsentOptions);
});
exports.getIsLegitimateInterest = getIsLegitimateInterest;
var getStartTimeIncrementMinutes = (0, _reselect.createSelector)([getCustomParams], function (customParams) {
  return (0, _get.default)('startTimeIncrementMinutes', customParams);
});
exports.getStartTimeIncrementMinutes = getStartTimeIncrementMinutes;
var getStartTimeIntervalMilliseconds = (0, _reselect.createSelector)([getStartTimeIncrementMinutes, getEvent], function (startTimeIncrementMinutes, event) {
  var startTimeMinuteValue = _enums.START_TIME_INTERVAL_VALUES[startTimeIncrementMinutes];
  return startTimeMinuteValue === _enums.START_TIME_INTERVALS.MEETING_DURATION ? event.duration : startTimeMinuteValue * _dates.MINUTES_TO_MILLIS;
});
exports.getStartTimeIntervalMilliseconds = getStartTimeIntervalMilliseconds;
var getAvailableTimePeriods = (0, _reselect.createSelector)([getBookInfo, _RequestStatusSelectors.getIsFetchingPublicAvailability, _RequestStatusSelectors.availabilityFetchFailed, _RESTParamSelectors.getCurrentTime], function (bookInfo, isFetchingPublicAvailability, availabilityFetchFailed, currentTime) {
  if (isFetchingPublicAvailability || availabilityFetchFailed) {
    return (0, _immutable.List)();
  }

  var allUsersBusyTimes = bookInfo.allUsersBusyTimes,
      linkType = bookInfo.linkType,
      customParams = bookInfo.customParams;
  var availability = customParams.availability;

  var availabilityMilliseconds = _AvailabilityMilliseconds.default.fromAvailability(availability);

  return (0, _utils.freeDateTimeRanges)({
    availability: availabilityMilliseconds,
    bookableUsersBusyTimes: allUsersBusyTimes.map(function (userBusyTimes) {
      return userBusyTimes.busyTimes;
    }),
    settings: customParams,
    linkType: linkType,
    now: currentTime
  });
});
exports.getAvailableTimePeriods = getAvailableTimePeriods;
var getOffline = (0, _reselect.createSelector)([getBookInfo, getForceOffline], function (bookInfo, forceOffline) {
  return forceOffline || bookInfo.offline;
});
exports.getOffline = getOffline;
var getAvailableStartTimes = (0, _reselect.createSelector)([getStartTimeIntervalMilliseconds, getAvailableTimePeriods, getMeetingLength, _RequestStatusSelectors.getIsFetchingPublicAvailability], function (startTimeIntervalMilliseconds, availableTimePeriods, duration, isFetchingPublicAvailability) {
  var availableTimes = isFetchingPublicAvailability ? (0, _immutable.List)() : availableTimePeriods;
  return (0, _TimeRangeListUtils.getFlexibleIntervalStartTimes)(availableTimes, duration, startTimeIntervalMilliseconds);
});
exports.getAvailableStartTimes = getAvailableStartTimes;
var getGroupedAvailableTimes = (0, _reselect.createSelector)([getAvailableStartTimes, getUserTimezone], function (startTimes, userTimezone) {
  return startTimes.groupBy(function (startTimestamp) {
    return _I18n.default.moment(startTimestamp).tz(userTimezone).format('YYYY-MM-DD');
  });
});
exports.getGroupedAvailableTimes = getGroupedAvailableTimes;
var getAvailableDates = (0, _reselect.createSelector)([getGroupedAvailableTimes], function (groupedAvailableTimes) {
  return groupedAvailableTimes.keySeq();
});
exports.getAvailableDates = getAvailableDates;
var isSelectedDateAvailable = (0, _reselect.createSelector)([getAvailableDates, getEvent], function (availableDates, event) {
  return availableDates.includes(event.dateString);
});
exports.isSelectedDateAvailable = isSelectedDateAvailable;
var getAvailableStartTimesForSelectedDate = (0, _reselect.createSelector)([getGroupedAvailableTimes, getEvent], function (groupedAvailableTimes, event) {
  return groupedAvailableTimes.get(event.dateString) || (0, _immutable.List)();
});
exports.getAvailableStartTimesForSelectedDate = getAvailableStartTimesForSelectedDate;
var getShouldAutoSubmit = (0, _getIn.default)(['bookInfo', 'customParams', 'shouldAutoSubmit']);
exports.getShouldAutoSubmit = getShouldAutoSubmit;
var shouldShowEmailForm = (0, _reselect.createSelector)([getBookInfo, _FormFieldValidationSelector.getStagedFormState, getShouldAutoSubmit], function (bookInfo, stagedFormState, shouldAutoSubmit) {
  return (0, _get.default)('ownerPrioritized', bookInfo) && stagedFormState && (!stagedFormState.email || !shouldAutoSubmit);
});
exports.shouldShowEmailForm = shouldShowEmailForm;
var shouldCenterPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getFormFields], function (formFields) {
  return formFields.isEmpty();
});
exports.shouldCenterPropertyForm = shouldCenterPropertyForm;